/* eslint-disable react-hooks/rules-of-hooks */
//TODO: Remove Optionally calls to hooks (useQuery, useEffect)
import React from 'react';
import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { getAccessToken } from '../utils/auth';
import { AnalyticsInitializer } from './AnalyticsInitializer';
import GET_USER_INFO from './queries/getUserInfoQuery';

/**
 * @typedef {object} PendoProviderProps
 * @property {*} [children]
 */

/**
 * @param {PendoProviderProps} props
 */
const PendoProvider = props => {
  if (!process.env.PENDO_API_KEY) {
    return <>{props.children}</>;
  }

  const { data } = useQuery(GET_USER_INFO, {
    skip: !getAccessToken()
  });

  useEffect(() => {
    if (!data) {
      return;
    }
    AnalyticsInitializer.init(
      data.currentUser,
      data.getUserMddapOrganizationName,
      data.getUserMddapOrganizationUnitNames
    );
  }, [data]);

  return <>{props.children}</>;
};

export default PendoProvider;
